import React, { useContext, useEffect, useState } from 'react';
import { BarChart2 } from 'react-feather';
// import { format, parseISO } from 'date-fns';
import { FundContext } from '../FundPage';
import useWindowDimensions, { useRemote } from '../../../../Utils/Utils';
import { PageContentBodyGrid } from '../../../Shared/Page/Page';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import Table from '../../../../components/Table/Table';
import FlexWrapper from '../../../FlexWrapper';
import Divider from '../../../../components/Divider';
import LoadingIcon from '../../../../components/LoadingIcon';
import "../FundPage.scss"
import SearchField from '../../../../components/Input/SearchField';


const FundInvestmentMix = ({ portfolio }) => {
	const { setSelectedTab, holdings } = useContext(FundContext)
	const width = useWindowDimensions().width
	const remote = useRemote()
	const [data, setData] = useState([])
	const [pieImage, setPieImage] = useState(null)
	const [loading, setLoading] = useState(true)

	const [dates, setDates] = useState([])
	const [selectedDate, setSelectedDate] = useState(null)

	const [selectedHoldings, setSelectedHoldings] = useState([])

	useEffect(() => {
		if (!holdings) {
			return;
		}
		const availableDates = Object.keys(holdings);
		setDates(availableDates);

	}, [holdings])

	useEffect(() => {
		if (dates && dates.length > 0 && !selectedDate) {
			setSelectedDate(dates[0])
		}
	}, [dates])

	useEffect(() => {
		if (!selectedDate || !holdings) {
			return;
		}
		setSelectedHoldings(holdings[selectedDate])
	}, [selectedDate, holdings])

	useEffect(() => {
		setSelectedTab(portfolio ? "Allocation" : "Investment Mix")
		console.log("Setting data for selectedHoldings ", selectedHoldings)
		if (selectedHoldings?.length > 0) {
			const assetClasses = {}
			selectedHoldings.forEach(h => {
				const currentClass = assetClasses[h.assetClass]
					? {
						assetClass: assetClasses[h.assetClass].assetClass,
						// targetWeight: assetClasses[h.assetClass].targetWeight + h.targetWeight,
						currentWeight: assetClasses[h.assetClass].currentWeight + h.currentWeight,
						assetClassCategory: assetClasses[h.assetClass].assetClassCategory,
					}
					: {
						assetClass: h.assetClass,
						// targetWeight: h.targetWeight,
						currentWeight: h.currentWeight,
						assetClassCategory: h.assetClassCategory,
					};
				assetClasses[h.assetClass] = currentClass;
			})
			const classesArray = Object.keys(assetClasses).map(key => assetClasses[key])

			if (portfolio) { // Get Categories and their values to display on allocations table
				const growth = classesArray.reduce((acc, clss) => {
					if (clss.assetClassCategory === "Growth") {
						return { currentWeight: acc.currentWeight + clss.currentWeight, targetWeight: acc.targetWeight + clss.targetWeight, assetClassCategory: "Growth" } // NO COLOUR Growth
						return { currentWeight: acc.currentWeight + clss.currentWeight, targetWeight: acc.targetWeight + clss.targetWeight, assetClassCategory: "Growth", colour: "#fff", backgroundColor: "#0e8efd", borderBottom: "none" } // PRIMARY COLOUR Growth
						return { currentWeight: acc.currentWeight + clss.currentWeight, targetWeight: acc.targetWeight + clss.targetWeight, assetClassCategory: "Growth", colour: "#fff", backgroundColor: "#0eb19e", borderBottom: "none" } // GREEN COLOUR Growth
					} else return acc
				}, { currentWeight: 0, targetWeight: 0, assetClassCategory: "Growth" }); // NO COLOUR Growth
				// }, { currentWeight: 0, targetWeight: 0, assetClassCategory: "Growth", backgroundColor: "#0e8efd", borderBottom: "none"  }); // PRIMARY COLOUR Growth
				// }, { currentWeight: 0, targetWeight: 0, assetClassCategory: "Growth", backgroundColor: "#0eb19e", borderBottom: "none" }); // GREEN COLOUR Growth

				const defensive = classesArray.reduce((acc, clss) => {
					if (clss.assetClassCategory === "Defensive") {
						return { currentWeight: acc.currentWeight + clss.currentWeight, targetWeight: acc.targetWeight + clss.targetWeight, assetClassCategory: "Defensive" } // NO COLOUR Defensive
						return { currentWeight: acc.currentWeight + clss.currentWeight, targetWeight: acc.targetWeight + clss.targetWeight, assetClassCategory: "Defensive", colour: "#fff", backgroundColor: "#0eb19e", borderBottom: "none" }  // GREEN COLOUR Defensive
						return { currentWeight: acc.currentWeight + clss.currentWeight, targetWeight: acc.targetWeight + clss.targetWeight, assetClassCategory: "Defensive", colour: "#fff", backgroundColor: "#06467D", borderBottom: "none" } // DARK BLUE Defensive

					} else return acc
				}, { currentWeight: 0, targetWeight: 0, assetClassCategory: "Defensive" });  // NO COLOUR Defensive
				// }, { currentWeight: 0, targetWeight: 0, assetClassCategory: "Defensive", colour: "#fff", backgroundColor: "#0eb19e",  borderBottom: "none" }); // GREEN COLOUR Defensive
				// }, { currentWeight: 0, targetWeight: 0, assetClassCategory: "Defensive", colour: "#fff", backgroundColor: "#06467D", borderBottom: "none" });  // DARK BLUE Defensive

				const allClassesAndCategories = [
					growth,
					getClass(assetClasses, "Australian Equities", null, "Growth"), // NO COLOUR
					getClass(assetClasses, "International Equities", null, "Growth"), // NO COLOUR
					getClass(assetClasses, "Property", null, "Growth"), // NO COLOUR
					getClass(assetClasses, "Infrastructure", null, "Growth"), // NO COLOUR

					// getClass(assetClasses, "Australian Equities", "#56D1C3", "Growth"), // GREEN Growth
					// getClass(assetClasses, "International Equities", "#9ff0e7", // GREEN Growth
					// getClass(assetClasses, "Property", "#cdfaf5", // GREEN Growth
					// getClass(assetClasses, "Infrastructure", "#e8fffc", // GREEN Growth

					// getClass(assetClasses, "Australian Equities", "#68b4f6", "Growth"), // PRIMARY COLOUR Growth
					// getClass(assetClasses, "International Equities", "#9fccf2", "Growth"), // PRIMARY COLOUR Growth
					// getClass(assetClasses, "Property", "#c1def7", "Growth"), // PRIMARY COLOUR Growth
					// getClass(assetClasses, "Infrastructure", "#e5f1f9", "Growth"), // PRIMARY COLOUR Growth
					defensive,
					getClass(assetClasses, "Alternatives and Other", null, "Defensive"), // NO COLOUR
					getClass(assetClasses, "Australian Fixed Income", null, "Defensive"), // NO COLOUR
					getClass(assetClasses, "International Fixed Income", null, "Defensive"), // NO COLOUR
					getClass(assetClasses, "Cash", null, "Defensive"), // NO COLOUR

					// getClass(assetClasses, "Alternatives and Other", "#4379a7", "Defensive", "#fff"), // DARK BLUE Defensice
					// getClass(assetClasses, "Australian Fixed Income", "#7ba1c4", "Defensive"), // DARK BLUE Defensice
					// getClass(assetClasses, "International Fixed Income", "#a9c1d6", "Defensive"), // DARK BLUE Defensice
					// getClass(assetClasses, "Cash", "#d9e5ef", "Defensive"), // DARK BLUE Defensice

					// getClass(assetClasses, "Alternatives and Other", "#56D1C3", "Defensive"), // Green Defensive
					// getClass(assetClasses, "Australian Fixed Income", "#9ff0e7", "Defensive"), // Green Defensive
					// getClass(assetClasses, "International Fixed Income", "#cdfaf5", "Defensive"), // Green Defensive
					// getClass(assetClasses, "Cash", "#e8fffc", "Defensive"), // Green Defensive
				]

				// Pie Chart with Two Rings configuration
				// const pieData = {
				// 	Growth: {
				// 		"Australian Equities": assetClasses["Australian Equities"] ? assetClasses["Australian Equities"].currentWeight : 0,
				// 		"International Equities": assetClasses["International Equities"] ? assetClasses["International Equities"].currentWeight : 0,
				// 		"Property": assetClasses["Property"] ? assetClasses["Property"].currentWeight : 0,
				// 		"Infrastructure": assetClasses["Infrastructure"] ? assetClasses["Infrastructure"].currentWeight : 0,
				// 	},
				// 	Defensive: {
				// 		"Alternatives and Other": assetClasses["Alternatives and Other"] ? assetClasses["Alternatives and Other"].currentWeight : 0,
				// 		"Australian Fixed Income": assetClasses["Australian Fixed Income"] ? assetClasses["Australian Fixed Income"].currentWeight : 0,
				// 		"International Fixed Income": assetClasses["International Fixed Income"] ? assetClasses["International Fixed Income"].currentWeight : 0,
				// 		"Cash": assetClasses["Cash"] ? assetClasses["Cash"].currentWeight : 0
				// 	}
				// }

				// const pieChartStyleConfig = {
				// 	width: 500,
				// 	height: 470,
				// 	//styles: { legend: "title-page-subheader" }, // change to other style ?
				// 	styles: { legend: "section-header-blue" }, // change to other style ?
				// 	backgroundColour: "#FFFFFF",
				// 	coloursOuter: ["#0e8efd", '#06467d'], // PRMIMARY & DARK-BLUE
				// 	coloursInnerSet: { "#0e8efd": ['#68b4f6', '#9fccf2', '#c1def7', '#e5f1f9'], '#06467d': ['#4379a7', '#7ba1c4', '#a9c1d6', '#d9e5ef'] }, // PRMIMARY & DARK-BLUE
				// 	// coloursOuter: ["#0e8efd", '#0eb19e'], // PRIMARY & GREEN
				// 	// coloursInnerSet: { "#0e8efd": ['#52aaf6', '#93c4ee', '#b9d8f3', '#dae9f5'], '#0eb19e': ["#56D1C3", "#9ff0e7", "#cdfaf5", "#e8fffc"] }, // PRIMARY & GREEN
				// 	// coloursOuter: ["#0eb19e", '#06467d'], // GREEN & DARK-BLUE
				// 	// coloursInnerSet: { '#0eb19e': ["#56D1C3", "#9ff0e7", "#cdfaf5", "#e8fffc"], '#06467d': ['#30628d', '#6e94b5', '#a9c1d6', '#d9e5ef'] }, // GREEN & DARK-BLUE
				// 	// coloursOuter: ["#7A2E8F", "#154A9A"], // CFS Colours
				// 	// coloursInnerSet: { "#7A2E8F": ["#9458A3", "#BC96C5", "#DECBE3", "#F1E9F4"], "#154A9A": ["#466FAF", "#8BA4CC", "#C6D2E6", "#E8EDF5"] }, // CFS Colours
				// 	title: { value: "" },
				// 	data: { value: "${PORTFOLIO_ALLOCATION}" },
				// 	enableMirror: true,
				// 	innerRingPerc: 0.75,
				// 	donutRadiusPerc: 0.4,
				// 	dividerWidth: 1
				// }

				// const pieChartConfig = {
				// 	"data": { "data": { "PORTFOLIO_ALLOCATION": JSON.stringify(pieData) } },
				// 	"configuration": JSON.stringify(pieChartStyleConfig),
				// 	"className": "PieChartTwoRing",
				// 	"dataSuffix": null,
				// };

				// remote.post(`ssrender/CFS Fund Update`, pieChartConfig).then(resp => {
				// 	setPieImage(resp.data);
				// 	setLoading(false)
				// 	setData(allClassesAndCategories)
				// }).catch(() => {
				// 	setPieImage(null)
				// 	setLoading(false)
				// 	setData(allClassesAndCategories)
				// })
				setLoading(false)
				setData(allClassesAndCategories)
			} else {
				setData(classesArray)
				setLoading(false)
			}
		} else {
			setLoading(false)
			setData([])
		}
	}, [selectedHoldings])

	function getClass(obj, key, backgroundColor, cat, colour) {
		return {
			assetClass: key,
			targetWeight: obj[key] ? obj[key].targetWeight : 0,
			currentWeight: obj[key] ? obj[key].currentWeight : 0,
			assetClassCategory: cat,
			backgroundColor: backgroundColor,
			colour: colour,
			borderTop: "none",
			borderBottom: "none"
		}
	}

	const headers = [
		{
			text: <div className='sorting-header left'>{`${portfolio ? "Asset Class" : "Investment Category"}`} </div>
		},
		{
			text: <div className='sorting-header right'>{`Target${portfolio ? "" : " Investment Mix"}`} </div>
		},
		{
			text: <div className='sorting-header right'>{`Actual${portfolio ? "" : " Investment Mix"}`} </div>
		},
	]
	const colWidths = ["40%", "30%", "30%"]
	const dataMap = () => {
		return data.map((item) => {
			return (
				<tr key={item.assetClass} style={item.assetClassCategory === 'Defensive' && !item.assetClass ? { borderTop: 'solid 24px #fff' } : null}>
					<td>{item.assetClass ? item.assetClass : item.assetClassCategory}</td>
					<td style={{ textAlign: "right" }}>{item.targetWeight ? item.targetWeight.toFixed(2) + "%" : "-"}</td>
					<td style={{ textAlign: "right" }}>{item.currentWeight.toFixed(2)}%</td>
				</tr>
			)
			// return ( // render with pie chart
			// 	<tr key={item.assetClass} style={item.assetClassCategory === 'Defensive' && !item.assetClass ? { borderTop: 'solid 24px #fff' } : null}>
			// 		<td style={{ backgroundColor: item.backgroundColor, color: item.colour, borderTop: item.borderTop, borderBottom: item.borderBottom }}>{item.assetClass ? item.assetClass : item.assetClassCategory}</td>
			// 		<td style={{ textAlign: "right", backgroundColor: item.backgroundColor, color: item.colour, borderTop: item.borderTop, borderBottom: item.borderBottom }}>{item.targetWeight.toFixed(2)}%</td>
			// 		<td style={{ textAlign: "right", backgroundColor: item.backgroundColor, color: item.colour,  borderTop: item.borderTop, borderBottom: item.borderBottom}}>{item.currentWeight.toFixed(2)}%</td>
			// 	</tr>
			// )
		})
	}

	return (
		<>
			<PageGridItem container col="1 / span 12" gap='m' direction='col' style={{ maxWidth: '1000px' }} /*style={{ maxWidth: portfolio ? '1580px' : '1000px' }} */>
				<FlexWrapper fullWidth justify={"space-between"}>
					<DetailSectionHeader header={portfolio ? "Allocation" : "Investment Mix"} icon={<BarChart2 />} />
                    <SearchField
                        placeholder="Date"
                        onChange={(e) => setSelectedDate(e.value)}
                        value={selectedDate && { label: selectedDate, value: selectedDate }}
                        options={dates.map((s, index) => ({ label: s, value: s }))}
                        width="m"
                        size="small"
                    />
					{/* <p className="investment-mix-date" >Last Updated: {format(parseISO(data.lastUpdated), "dd/MM/yyyy")}</p> */}
				</FlexWrapper>
				<Divider marginTop={"1rem"} />
			</PageGridItem>
			<PageGridItem container col="1 / span 12" gap='m' direction='col' style={portfolio ? { overflowY: "auto", height: "calc(100vh - 26.5rem)" } : { maxWidth: '1000px' }}>
				<PageContentBodyGrid paddingTop='0rem'>
					<PageGridItem container col={"1 / span 12"} gap='s' direction={width < 1200 ? 'col' : 'row'} style={{ maxWidth: '1000px' }}>
						{/* <PageGridItem container col={"1 / span 12"} gap='m' direction={width < 1200 ? 'col' : 'row'} style={{ maxWidth: portfolio ? "1580px" : '1000px' }}> */}
						{loading
							? <LoadingIcon centered />
							: <Table headers={headers} colWidths={colWidths} dataMap={dataMap()} />
						}
						{/* {portfolio && // Pie Chart Image
							<div className='sample-chart'>
								{loading ? <div style={{ width: 360, height: 210 }}><LoadingIcon centered size={70} /></div> : pieImage && <img alt="category chart" style={{ width: 590 }} src={"data:image/png;base64," + pieImage} />}
							</div>
						} */}
					</PageGridItem>
				</PageContentBodyGrid>
			</PageGridItem>
		</>
	);
}

export default FundInvestmentMix;